import type { ComponentProps } from 'react'
import Signature from '../../shared/Signature'

type Props = ComponentProps<typeof Signature>

export default function Step8_Signature(props: Props) {
  return <Signature {...props} />
}

